import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import { setWaiting } from './components/updatePrompt';
import { lockNativeZoom } from './platform';

// Inside the native app only: no zoom-on-focus (see platform.lockNativeZoom).
lockNativeZoom();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Opens with no network once visited (service-worker.js). Production builds
// only. A new version waits for the athlete to ask for it (UpdateBanner).
registerServiceWorker({ onUpdate: setWaiting });
